<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-content">
        <div class="footer-section">
          <p class="footer-text">
            © {{ currentYear }} CodePod Ariel Podzorski. Alle Rechte vorbehalten.
          </p>
        </div>
        <div class="footer-links">
          <router-link to="/impressum" class="footer-link">
            Impressum
          </router-link>
          <router-link to="/datenschutz" class="footer-link">
            Datenschutz
          </router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const currentYear = computed(() => new Date().getFullYear())
</script>

<style scoped>
.footer {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  color: #333;
  padding: 2rem 0;
  position: relative;
  z-index: 200;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.footer-section {
  flex: 1;
}

.footer-text {
  color: #666;
  font-size: 0.9rem;
  margin: 0;
}

.footer-links {
  display: flex;
  gap: 1.5rem;
}

.footer-link {
  color: #555;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;
  position: relative;
}

.footer-link:hover {
  color: #00d1b2;
}

.footer-link::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background: #00d1b2;
  transition: width 0.3s ease;
}

.footer-link:hover::after {
  width: 100%;
}

@media (max-width: 768px) {
  .footer {
    padding: 1.5rem 0;
  }

  .footer-container {
    padding: 0 1rem;
  }

  .footer-content {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
  }

  .footer-text {
    font-size: 0.8rem;
  }

  .footer-link {
    font-size: 0.8rem;
  }
}
</style>
